import React from 'react';
import { FederationMembersPage } from '../../components/FederationMembersPage';
const members = [{
  name: 'Репко Олена',
  role: 'Голова навчально-методичної комісії'
}, {
  name: 'Шалагін Михайло',
  role: 'Член навчально-методичної комісії',
  email: 'mihashalagin@gmail.com'
}, {
  name: 'Маренич Валентина',
  role: 'Членкиня навчально-методичної комісії',
  email: 'vertykal.kh@gmail.com'
}];
export function EducationMethodCommission() {
  return <FederationMembersPage title="Навчально-методична комісія" subtitle="Навчально-методична комісія скельного комітету ФАіСУ" members={members} data-id="element-561" />;
}